import InstrumentInstanceCollection from "@/collections/lab/InstrumentInstanceCollection";
import InstrumentJigCollection from "@/collections/lab/InstrumentJigCollection";
import InstrumentTestCollection from "@/collections/lab/InstrumentTestCollection";
import JigCollection from "@/collections/lab/JigCollection";
import LabServiceModel from "@/models/LabServiceModel";

export default class InstrumentModel extends LabServiceModel {
  modelName() {
    return "instrument";
  }
  icon() {
    return "clipboard-list";
  }
  defaults() {
    return {
      id: null,
      name: null,
      abbrev: null,
      description: null,
      capacity: null,
      runtime: null,
      runtime_display: null,
      created_at: null,
      updated_at: null,
      deleted_at: null,
      instrument_tests: [],
      instrument_instances: [],
      instrument_jigs: [],
      jigs: []
    };
  }
  mutations() {
    return {
      id: val => this.nullStringMutator(val),
      name: val => this.nullStringMutator(val),
      abbrev: val => this.nullStringMutator(val),
      description: val => this.nullStringMutator(val),
      capacity: Number,
      runtime: Number,
      runtime_display: val => this.nullStringMutator(val),
      created_at: (val) => this.nullStringMutator(val),
      updated_at: (val) => this.nullStringMutator(val),
      deleted_at: (val) => this.nullStringMutator(val),
    };
  }
  validation() {
    return {};
  }
  getInstances() {
    return this.getRelatedCollection(
      new InstrumentInstanceCollection(),
      "instrument_instances"
    );
  }
  getInstrumentJigs() {
    return this.getRelatedCollection(
      new InstrumentJigCollection(),
      "instrument_jigs"
    );
  }
  getJigs() {
    return this.getRelatedCollection(new JigCollection(), "jigs");
  }

  getInstrumentTests() {
    return this.getRelatedCollection(
      new InstrumentTestCollection(),
      "instrument_tests"
    );
  }
  formatAbbrev() {
    return this.abbrev.length ? this.abbrev : this.name;
  }
  static formatRuntimeOptions() {
    return {
      hours: "Hours",
      minutes: "Minutes",
      seconds: "Seconds"
    };
  }
  static formatRuntime(time, display_opt) {
    switch (display_opt.toLowerCase()) {
      case "hours":
        return time / 3600;
      case "minutes":
        return time / 60;
      default:
        return time;
    }
  }

  static formatRuntimeRaw(number, display_opt) {
    switch (display_opt.toLowerCase()) {
      case "hours":
        return number * 3600;
      case "minutes":
        return number * 60;
      default:
        return number;
    }
  }
}
